module.exports = __webpack_public_path__ + "img/zen-pond.c9bb4ac3.webp";